import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

const ScrollToTopLink = ({ to, children, className, ...props }) => {
  const handleClick = () => {
    // Scroll to top of the page
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }

  return (
    <RouterLink
      to={to}
      viewTransition
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children}
    </RouterLink>
  )
}

export default ScrollToTopLink
